import ReportPage from "../../components/ReportPage";
import { downloadDistributionAudit } from "../../API";

const schema = {
  title: "Distribution Audit Report",
  params: [
    { name: "banner", label: "Banner", type: "select", route: "banners", required: true },
    {
      name: "products",
      label: "Products",
      type: "multiselect",
      route: "products/for-report",
      cascadesFrom: "banner",
      clearOnManufacturerChange: true,
      buildQueryFn: (banner, commonParams) => {
        const p = new URLSearchParams();
        if (commonParams.manufacturer?.id) p.set("manufacturerId", commonParams.manufacturer.id);
        p.set("bannerId", banner.id);
        (commonParams.provinces ?? []).forEach((prov) => p.append("provinceIds", prov.id));
        return "?" + p.toString();
      },
      fields: ["description", "formatQut", "format"],
      payloadKey: "productIds",
      required: true,
    },
  ],
  downloadFn: downloadDistributionAudit,
};

export default function DistributionAuditReport() {
  return <ReportPage schema={schema} />;
}
